import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };
  return <div className="min-h-screen bg-brand-offwhite flex flex-col items-center justify-center p-4 font-sans selection:bg-brand-sage selection:text-brand-forest" data-id="element-1011">
      <Link to="/" className="flex items-center gap-2 mb-8" data-id="element-1012">
        <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves Pro Logo" className="w-8 h-8" data-id="element-1013" />
        <span className="font-serif font-semibold text-xl text-brand-dark" data-id="element-1014">
          Eaves Pro
        </span>
      </Link>

      <div className="bg-white rounded-2xl border border-brand-light shadow-sm p-8 max-w-md w-full mx-4" data-id="element-1015">
        {!submitted ? <>
            <h1 className="font-serif font-semibold text-2xl text-brand-dark mb-2" data-id="element-1016">
              Sign in to Eaves Pro
            </h1>
            <p className="text-sm text-brand-muted mb-6" data-id="element-1017">
              Enter your email and we'll send you a magic link.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1018">
              <div data-id="element-1019">
                <label htmlFor="email" className="sr-only" data-id="element-1020">
                  Email address
                </label>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="name@example.com" required className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-1021" />
              </div>
              <button type="submit" className="w-full bg-brand-forest hover:bg-brand-forestHover text-white py-3 rounded-xl font-medium transition-colors" data-id="element-1022">
                Send magic link
              </button>
            </form>
          </> : <div className="text-center py-4" data-id="element-1023">
            <div className="w-16 h-16 bg-brand-sage rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1024">
              <CheckCircle2 size={32} className="text-brand-forest" data-id="element-1025" />
            </div>
            <h1 className="font-serif font-semibold text-2xl text-brand-dark mb-2" data-id="element-1026">
              Check your email
            </h1>
            <p className="text-sm text-brand-muted mb-8" data-id="element-1027">
              We sent a link to{' '}
              <span className="font-medium text-brand-dark" data-id="element-1028">{email}</span>.
              Click it to sign in.
            </p>
            <button onClick={() => setSubmitted(false)} className="text-sm font-medium text-brand-forest hover:text-brand-dark transition-colors" data-id="element-1029">
              Resend link
            </button>
          </div>}
      </div>

      {!submitted && <p className="mt-8 text-sm text-brand-muted" data-id="element-1030">
          Don't have an account?{' '}
          <Link to="/login" className="font-medium text-brand-forest hover:text-brand-dark transition-colors" data-id="element-1031">
            Sign up free
          </Link>
        </p>}
    </div>;
}